export default __webpack_public_path__ + "static/21_36-e7be354db87e3b7e0c2f650be01e87b1.png";